import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { setPageSeo } from "../lib/seo";
import { BUSINESS } from "../lib/business";

export default function Refund() {
  useEffect(() => {
    window.scrollTo(0, 0);
    setPageSeo({
      title: "Refund & Cancellation Policy — DevzCorner",
      description:
        "Refund and cancellation timelines for DevzCorner digital services, custom development, and physical products.",
      path: "/refund",
    });
  }, []);

  return (
    <main className="relative bg-ink-0 text-white min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow pt-32 pb-24 px-6 md:px-10 max-w-4xl mx-auto w-full">
        <h1 className="font-display text-4xl md:text-5xl mb-8">Refund &amp; Cancellation Policy</h1>
        <div className="prose prose-invert max-w-none text-zinc-400 font-light leading-relaxed space-y-6">
          <p>Last updated: October 2026</p>
          <p>
            This Refund &amp; Cancellation Policy applies to purchases and project engagements with{" "}
            {BUSINESS.legalName} ({BUSINESS.brandName}), Bengaluru, India. Please read it before making a payment.
          </p>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">1. Cancellation</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong className="text-zinc-300">Before work starts:</strong> If you cancel after paying an advance but before we begin work under the Statement of Work (SOW), you may request a full refund of unused fees.
            </li>
            <li>
              <strong className="text-zinc-300">After work starts:</strong> Cancellation must be requested in writing (email). Fees for completed milestones are non-refundable. Any unused prepaid amount for incomplete milestones may be refunded on a prorated basis after review.
            </li>
            <li>
              <strong className="text-zinc-300">Discovery call:</strong> Free discovery calls can be cancelled or rescheduled anytime with no charge.
            </li>
          </ul>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">2. Digital Products and Software</h2>
          <p>
            Due to the nature of digital products and proprietary software access, we generally do not offer refunds once the software or digital product has been delivered or accessed, unless explicitly stated otherwise in a product&apos;s terms or a signed SOW.
          </p>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">3. Custom Development and Services</h2>
          <p>
            For custom software development, AI integration, and consulting, refund eligibility follows the milestones in your SOW. Payments for completed milestones are non-refundable. If a project is cancelled before completion, unused prepaid fees for incomplete work may be refunded on a prorated basis.
          </p>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">4. Hardware and 3D Printed Products</h2>
          <p>
            For physical goods (custom 3D-printed products and hardware builds), refunds or replacements may be issued if the item arrives damaged or materially differs from agreed specifications. You must notify us within <strong className="text-zinc-300">14 days of delivery</strong>. Custom physical builds are otherwise non-refundable once fabrication has started, due to their bespoke nature.
          </p>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">5. Refund Timeline</h2>
          <p>
            Once a refund is approved, we will process it within <strong className="text-zinc-300">5–7 business days</strong> to the original payment method (or via the payment partner used for the transaction). Bank or card issuer posting times may add additional days.
          </p>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">6. How to Request a Refund or Cancel</h2>
          <p>
            Email{" "}
            <a href={`mailto:${BUSINESS.email}`} className="text-white underline hover:text-zinc-300 transition-colors">
              {BUSINESS.email}
            </a>{" "}
            or call{" "}
            <a href={BUSINESS.phoneHref} className="text-white underline hover:text-zinc-300 transition-colors">
              {BUSINESS.phoneDisplay}
            </a>{" "}
            with your name, payment/order reference, and reason. We review requests promptly and confirm the outcome by email.
          </p>

          <h2 className="text-white text-2xl font-display mt-8 mb-4">7. Contact</h2>
          <p>
            {BUSINESS.legalName}<br />
            {BUSINESS.addressOneLine}<br />
            Phone:{" "}
            <a href={BUSINESS.phoneHref} className="text-white underline hover:text-zinc-300 transition-colors">
              {BUSINESS.phoneDisplay}
            </a>
            <br />
            Email:{" "}
            <a href={`mailto:${BUSINESS.email}`} className="text-white underline hover:text-zinc-300 transition-colors">
              {BUSINESS.email}
            </a>
          </p>
        </div>
      </div>
      <Footer />
    </main>
  );
}
